'use strict';
import angular from 'angular';

angular.module('orders.constants', [])
    .constant('OrderColumns', {
        ID: 'id'
    });